import React from 'react';

import A from '@adsk/alloy-react-a';
import { Flex } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

import { PLAN_TASK_TITLE_NAME_MAX_WIDTH } from './PlanTaskTitle.consts';
import { formatUniqueId } from '../../../helpers';
import { usePlanTaskLink } from '../../hooks';
import { Task } from '../../types';
import PlanTaskName from '../PlanTaskName/PlanTaskTitle';

interface PlanTaskTitleProps {
  task: Task;
  linkEnabled?: boolean;
  disabled?: boolean;
}

const PlanTaskTitle = ({
  task,
  linkEnabled = false,
  disabled = false,
}: PlanTaskTitleProps) => {
  const planTaskLink = usePlanTaskLink(task);
  const formattedId = `#${formatUniqueId(task.uniqueId)}`;
  const showLink = linkEnabled && !disabled;
  const nameFontWeight = disabled
    ? theme.typography.bodyMedium.fontWeight
    : theme.typography.bodyMediumBold.fontWeight;

  return (
    <Flex
      alignItems="center"
      typography={disabled ? 'bodyMedium' : 'bodyMediumBold'}
      color={disabled ? 'charcoal700' : 'charcoal900'}
      style={{
        gap: '4px',
        textDecorationLine: disabled ? 'line-through' : 'none',
      }}
    >
      {showLink ? (
        <A href={planTaskLink} target="_blank">
          {formattedId}
        </A>
      ) : (
        <div>{formattedId}</div>
      )}
      <div>-</div>
      <PlanTaskName
        task={task}
        maxWidth={PLAN_TASK_TITLE_NAME_MAX_WIDTH}
        fontWeight={nameFontWeight}
      />
    </Flex>
  );
};

export default PlanTaskTitle;
